import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import path from 'enums/path';
import qs from 'qs';
import { saleClean, saleSet } from 'state/actions/sales';
import { invoiceClean } from 'state/actions/invoices';
import headerLogo from 'assets/img/logo_200x40px Amarillo.png';
import Button from 'components/Button';
import ErrorMessage from 'components/ErrorMessage';
import InputControl from 'components/InputControl';
import SmallParagraph from 'components/SmallParagraph';
import BillingProblemsMessage from 'components/BillingProblemsMessage';
import classes from './Home.module.scss';

const Home = () => {
  const history = useHistory();

  const { saleNumber, saleTotal, error } = useSelector(
    (state) => ({
      saleNumber: state.sales.number,
      saleTotal: state.sales.total,
      error: state.sales.error,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const onSubmitHandler = (event) => {
    event.preventDefault();
    dispatch(saleClean());
    dispatch(invoiceClean());
    history.push(
      `${path.RequestInvoice}?${qs.stringify({ saleNumber, saleTotal })}`
    );
  };

  return (
    <div className={classes.homePage}>
      <div className={classes.homeContainer}>
        <div className={classes.homeContent}>
          <div className={classes.homeContentHeader}>
            <img src={headerLogo} alt="Epicland" />
            <div className={classes.homeContentHeaderInfo}>
              <SmallParagraph>
                Increse el número de orden y el total de la compra para buscar
                su compra a facturar.
              </SmallParagraph>
            </div>
          </div>
          <div className={classes.homeContentBody}>
            {error && (
              <ErrorMessage data-testid="sale-lookup-error">
                {error.message}
              </ErrorMessage>
            )}
            <form className={classes.homeForm} onSubmit={onSubmitHandler}>
              <InputControl
                id="sale-number"
                label="Número de Orden"
                value={saleNumber || ''}
                onChange={(e) => {
                  const { value } = e.target;
                  dispatch(saleSet({ number: value.trim(), total: saleTotal }));
                }}
              />
              <InputControl
                id="sale-total"
                label="Total de la Compra"
                value={saleTotal || ''}
                onChange={(e) => {
                  const { value } = e.target;
                  dispatch(
                    saleSet({
                      number: saleNumber,
                      total: value.trim(),
                    })
                  );
                }}
              />
              <div className={classes.homeFormButtonContainer}>
                <Button type="submit" disabled={!(saleNumber && saleTotal)}>
                  Buscar
                </Button>
              </div>
            </form>
          </div>
          <div className={classes.homeContentFooter}>
            <SmallParagraph>
              Sólo se puede facturar dentro del mes corriente en el que se
              realizó la compra.
            </SmallParagraph>
            <SmallParagraph className={classes.billingProblemsMessage}>
              <BillingProblemsMessage />
            </SmallParagraph>
          </div>
        </div>
      </div>
      <div className={classes.homeBackground} />
    </div>
  );
};

export default Home;
